import { render, staticRenderFns } from "./path.vue?vue&type=template&id=1469c214"
import script from "./path.vue?vue&type=script&lang=js"
export * from "./path.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports